module.exports = __webpack_public_path__ + "img/banner1.121e6896.jpg";